import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=7f4cee7f&"
import script from "./Subjects.vue?vue&type=script&lang=js&"
export * from "./Subjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports